/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_Add_Table_TimeInputs */



/**
* | output |
* | --- |
* | "Give this table extra time" |
*
* @param {Timer_Add_Table_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_add_table_time = /** @type {((inputs?: Timer_Add_Table_TimeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Add_Table_TimeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Donner du temps supplémentaire à cette table")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dar tiempo extra a esta mesa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Dar tempo extra a esta mesa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dai tempo extra a questo tavolo")
	return /** @type {LocalizedString} */ ("Give this table extra time")
});